import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AdminPositionRequest } from 'src/app/models/position-role.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HumanResourcesService } from 'src/app/services/human-resources.service';

@Component({
  selector: 'app-modal-admin-position',
  templateUrl: './modal-admin-position.component.html',
  styleUrls: ['../modal-admin-area/modal-admin-area.component.scss']
})
export class ModalAdminPositionComponent implements OnInit {
  @Input() isCreating: boolean = true;
  @Input() newPosition: AdminPositionRequest = null;
  @Input() departments: [] = [];
  @Input() positions: any[] = [];
  positionSelected = null;
  loading = false;
  @Output() close = new EventEmitter<boolean>();

  constructor(
    private toastService: ToastrService,
    private rrhh: HumanResourcesService
  ) {

  }

  ngOnInit(): void {

  }

  createOrEdit() {
    if (this.isCreating) {
      this.loading = true;
      this.rrhh.createPosition(this.newPosition).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Puesto creado exitosamente");
          this.loading = false;
          this.close.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          this.toastService.error((error.error.message)?error.error.message:'Error al crear el puesto, intenta más tarde');
        }
      })
    } else {
      this.loading = true;
      this.rrhh.updatePosition(this.newPosition.id,this.newPosition).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Puesto editado exitosamente");
          this.loading = false;
          this.close.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          this.toastService.error((error.error.message)?error.error.message:'Error al editar el puesto, intenta más tarde');
        }
      })
    }
  }
}
